const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDisplayGroup(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icono",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M22.64,20.05v4h-4.22v18.16h-4v-20.16c0-1.11.9-2,2-2h6.22Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.78,22.05v20.16h-4v-18.16h-4.22v-4h6.22c1.1,0,2,.89,2,2Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 34.87,
    y: 55.95,
    width: 10.25,
    height: 4,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.56,33.08c0,1.5-.91,2.71-2.02,2.71h-28.88c-1.11,0-2.02-1.21-2.02-2.71V11.03c0-1.5.91-2.71,2.02-2.71h28.88c1.11,0,2.02,1.21,2.02,2.71v22.05Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.56,33.08c0,1.5-.91,2.71-2.02,2.71h-28.88c-1.11,0-2.02-1.21-2.02-2.71V11.03c0-1.5.91-2.71,2.02-2.71h28.88c1.11,0,2.02,1.21,2.02,2.71v22.05Z",
    style: {
      fill: "#313739"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.56,11.03v22.05c0,1.5-.91,2.71-2.02,2.71h-28.88c-1.11,0-2.02-1.21-2.02-2.71V11.03c0-1.5.91-2.71,2.02-2.71h28.88c1.11,0,2.02,1.21,2.02,2.71Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.87,68.97c0,1.5-.91,2.71-2.02,2.71H1.97c-1.11,0-2.01-1.21-2.01-2.71v-22.05c0-1.5.9-2.71,2.01-2.71h28.88c1.11,0,2.02,1.21,2.02,2.71v22.05Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.87,68.97c0,1.5-.91,2.71-2.02,2.71H1.97c-1.11,0-2.01-1.21-2.01-2.71v-22.05c0-1.5.9-2.71,2.01-2.71h28.88c1.11,0,2.02,1.21,2.02,2.71v22.05Z",
    style: {
      fill: "#313739"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.87,46.92v22.05c0,1.5-.91,2.71-2.02,2.71H1.97c-1.11,0-2.01-1.21-2.01-2.71v-22.05c0-1.5.9-2.71,2.01-2.71h28.88c1.11,0,2.02,1.21,2.02,2.71Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.04,68.97c0,1.5-.9,2.71-2.02,2.71h-28.87c-1.12,0-2.02-1.21-2.02-2.71v-22.05c0-1.5.9-2.71,2.02-2.71h28.87c1.12,0,2.02,1.21,2.02,2.71v22.05Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.04,68.97c0,1.5-.9,2.71-2.02,2.71h-28.87c-1.12,0-2.02-1.21-2.02-2.71v-22.05c0-1.5.9-2.71,2.02-2.71h28.87c1.12,0,2.02,1.21,2.02,2.71v22.05Z",
    style: {
      fill: "#313739"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.04,46.92v22.05c0,1.5-.9,2.71-2.02,2.71h-28.87c-1.12,0-2.02-1.21-2.02-2.71v-22.05c0-1.5.9-2.71,2.02-2.71h28.87c1.12,0,2.02,1.21,2.02,2.71Z",
    style: {
      fill: "#e0e0e0"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisplayGroup);
export default __webpack_public_path__ + "static/media/display-group.588cf16eaf312bf81b79d82af08ea1e3.svg";
export { ForwardRef as ReactComponent };